import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { MobileTaskDetail } from '@/features/tasks/mobile/MobileTaskDetail';

export const Route = createFileRoute('/_app/tasks/$taskId')({ component: TaskDetailPage });

/**
 * Dettaglio task mobile. Su desktop il dettaglio è il pannello della sezione, quindi si va là
 * portandosi l'id — ma il redirect vero lo fa il layout `tasks.tsx`, perché senza una vista
 * corrispondente questo componente non viene montato. Qui resta la stessa destinazione, per il
 * caso in cui un domani l'`Outlet` copra anche questa rotta.
 */
function TaskDetailPage() {
  const isMobile = useIsMobileShell();
  const { taskId } = Route.useParams();
  if (isMobile) return <MobileTaskDetail taskId={taskId} />;
  return <Navigate to="/tasks" search={{ task: taskId }} replace />;
}
